module.exports = __webpack_public_path__ + "static/media/groupBrand.dda969b0.svg";